export const TALKING_POINTS_LIST_APP_STATE_SLICE_KEY = 'talkingPointsList';
const TALKING_POINTS_LIST_STATE_KEYS = [
    'owner',
    'metric',
    'name',
    'page',
    'sortColumn',
    'sortDirection',
    'viewRootFolder',
    'includeEmptyFolders',
];
// The system default state excludes sortColumn and sortDirection
export const TALKING_POINTS_LIST_SYSTEM_DEFAULT_STATE = {
    owner: {
        me: true,
        shared_with_me: true,
        public: true,
    },
    metric: null,
    name: '',
    page: 1,
    viewRootFolder: null,
    includeEmptyFolders: true,
};
export { TALKING_POINTS_LIST_STATE_KEYS };
